import React from 'react';

export type TypeformContext = {
  showTypeform: boolean;
  setShowTypeform: () => void;
  setHideTypeform: () => void;
};

const typeformContext = React.createContext<TypeformContext | undefined>(undefined);

export const TypeformContextProvider = typeformContext.Provider;

export const useTypeformContext = () => {
  const context = React.useContext(typeformContext);
  if (!context) {
    throw new Error('useTypeformContext must be used within a TypeformContextProvider');
  }
  return context;
};
